import { TextField, Select, MenuItem, Box, Typography, ButtonBase, Alert, AlertTitle } from '@mui/material';
import FieldWrapper from '../FieldWrapper';
import { AlertTriangle } from 'lucide-react';

export default function Step12Pagamento({ data, onChange, errors }) {
  const showIBAN = data.modalita_pagamento === 'SDD (Addebito su Conto Corrente)';
  const coobbligatoWarning = data.intestatario_conto === 'Coobbligato' && !data.ha_coobbligato;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
          Modalità di pagamento
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Come vuoi effettuare i pagamenti?
        </Typography>
      </Box>

      <FieldWrapper label="Modalità" required error={errors?.modalita_pagamento} completed={!!data.modalita_pagamento}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {['SDD (Addebito su Conto Corrente)', 'Bollettino Postale'].map(opt => (
            <ButtonBase
              key={opt}
              onClick={() => onChange('modalita_pagamento', opt)}
              sx={{
                width: '100%',
                py: 1.5,
                px: 2,
                borderRadius: 2,
                fontSize: '0.875rem',
                fontWeight: 500,
                border: '2px solid',
                textAlign: 'left',
                justifyContent: 'flex-start',
                transition: 'all 0.2s',
                borderColor: data.modalita_pagamento === opt ? 'primary.main' : 'divider',
                bgcolor: data.modalita_pagamento === opt ? 'primary.light' : 'transparent',
                color: data.modalita_pagamento === opt ? 'primary.main' : 'text.secondary',
                '&:hover': { borderColor: 'primary.main' }
              }}
            >
              {opt}
            </ButtonBase>
          ))}
        </Box>
      </FieldWrapper>

      {showIBAN && (
        <Box sx={{ p: 2, bgcolor: 'action.hover', borderRadius: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FieldWrapper label="Codice IBAN" required error={errors?.codice_iban} completed={!!data.codice_iban} hint="IBAN italiano: IT seguito da 25 caratteri">
            <TextField 
              fullWidth 
              size="small" 
              value={data.codice_iban || ''} 
              onChange={e => onChange('codice_iban', e.target.value.toUpperCase())} 
              placeholder="IT60 X054 2811 1010 0000 0123 456" 
              inputProps={{ maxLength: 34, style: { textTransform: 'uppercase', letterSpacing: '0.1em', fontFamily: 'monospace' } }} 
            />
          </FieldWrapper>

          <FieldWrapper label="Intestatario conto corrente" error={errors?.intestatario_conto} completed={!!data.intestatario_conto}>
            <Select 
              fullWidth 
              size="small" 
              value={data.intestatario_conto || ''} 
              onChange={e => onChange('intestatario_conto', e.target.value)}
              displayEmpty
            >
              <MenuItem value="" disabled>Seleziona intestatario</MenuItem>
              <MenuItem value="Richiedente">Richiedente</MenuItem>
              <MenuItem value="Coobbligato">Coobbligato</MenuItem>
            </Select>
          </FieldWrapper>

          {coobbligatoWarning && (
            <Alert 
              severity="warning" 
              icon={<AlertTriangle size={18} />}
              sx={{ borderRadius: 2 }}
            >
              <Typography variant="caption" sx={{ display: 'block' }}>
                Hai selezionato "Coobbligato" come intestatario, ma non è presente un coobbligato nella pratica. Torna allo Step 2 per aggiungerne uno.
              </Typography>
            </Alert>
          )}
        </Box>
      )}
    </Box>
  );
}